import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import ParticipantsV2Store from '../Store';
import { State } from '../Store/Types';
import Body from './Body';
import Head from './Head';

interface Props {
  store: ParticipantsV2Store;
}

const busy = (state: State): boolean => {
  switch (state.kind) {
    case 'loading':
      return true;
    case 'ready':
    case 'error':
      return false;
    default:
      return assertNever(state);
  }
};

function Table({ store }: Props) {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card">
      <table className="w-full" aria-busy={busy(store.state)}>
        <Head store={store} />
        <Body store={store} />
      </table>
    </div>
  );
}

export default observer(Table);
